import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const SalesTransactionEnquiry = {
  type: 'SalesTransactionEnquiry',
  formTitle: 'Sales Transaction Enquiry',
  formUrl: '/Customers/TransactionEnquiry',
  screenReference: 'SALES_LEDGER_TRANSACTION_ENQUIRY',
  operations: ALLOW_EDIT,
};

export default SalesTransactionEnquiry;
